import * as React from 'react'

const SvgUserCircleIcon = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={60} height={60} rx={20} fill="#EFF4FF" />
    <path
      d="M18.75 40c2.92-3.097 6.884-5 11.25-5s8.33 1.903 11.25 5m-5.625-15.625a5.625 5.625 0 1 1-11.25 0 5.625 5.625 0 0 1 11.25 0Z"
      stroke="#155EEF"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgUserCircleIcon
